export function BrandMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#0E2140" />
      <path d="M10 46 L24 26 L32 36 L42 22 L54 46 Z" fill="#FDFBF7" />
      <path
        d="M46 10 l2 4 4.4.6-3.2 3.1.8 4.4-4-2.1-4 2.1.8-4.4-3.2-3.1 4.4-.6z"
        fill="#F5B301"
      />
    </svg>
  );
}
